export { clearWhenSettled }

// Form-input handler: reset a settled result to `idle` so the success/error message goes
// away as soon as the user starts editing. No-op while `submitting` keeps the in-flight
// state visible during the request.
function clearWhenSettled<R extends { kind: string }>(result: R, setResult: (r: R) => void, idle: R): void {
  if (result.kind !== 'idle' && result.kind !== 'submitting') setResult(idle)
}
